(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('FilterHelper', FilterHelper)

    /** @ngInject */
    function FilterHelper(LOCAL_STORAGE_ITEMS) {
        let allFilters = [];

        const FilterHelper = {
            getFilter,
            getFilters,
            setFilters
        }

        return FilterHelper;

        function getFilter(area, field) {
            const areaFilters = getFilters(area);

            if (!areaFilters) return;

            return areaFilters[field];
        }

        function getFilters(area) {
            if (!allFilters.length)
                loadFilters();

            return allFilters[area];
        }

        function setFilters(area, filters) {
            if (!allFilters.length)
                loadFilters();

            allFilters[area] = filters;

            saveFilters();
        }

        // Internal
        function saveFilters() {
            const jsonFilters = JSON.stringify({
                ...allFilters
            });

            localStorage.setItem(LOCAL_STORAGE_ITEMS.CUSTOM_FILTERS, jsonFilters);
        }

        function loadFilters() {
            const storageFilters = localStorage.getItem(LOCAL_STORAGE_ITEMS.CUSTOM_FILTERS);

            if (!storageFilters) return;

            allFilters = JSON.parse(storageFilters);
        }
    }
}());